import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExternalWsConfig } from '@core/models/built/procedure-step-config.model';
import { ProcedureStep } from '@core/models/procedures.model';
import { coreActions } from '@core/store/core.actions';
import { coreSelectors } from '@core/store/core.selectors';
import { FlowchartMode } from '@flowchart';
import { TranslocoService } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { filterTruthy } from '@utils';
import { Subscription } from 'rxjs';

import it from './i18n/external-ws-edit.it.json';

@Component({
  templateUrl: './external-ws-edit.component.html'
})
export class ExternalWsEditComponent implements OnInit, OnDestroy {

  @Input() step?: ProcedureStep;
  @Input() mode: FlowchartMode = 'edit';
  @Input() editForm!: FormGroup;

  externalWs$ = this.store.select(coreSelectors.cache.externalWs.selectAll);

  private subs = new Subscription();

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private translocoSvc: TranslocoService
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnInit() {
    this.subs.add(
      this.store.select(coreSelectors.accessToken).pipe(filterTruthy())
        .subscribe(token => this.store.dispatch(coreActions.cacheExternalWs()))
    );

    const config = this.step?.config as ExternalWsConfig;

    const configGroup = (this.editForm.get('config') as FormGroup);
    if (configGroup) {
      configGroup.addControl('wsId', this.fb.control(config?.wsId, [Validators.required]));
    } else {
      this.editForm.addControl('config', this.fb.group({
        wsId: [config?.wsId, [Validators.required]]
      }));
    }

    if (this.mode === 'view') {
      (this.editForm.get('config') as FormGroup).disable();
    }
  }

  ngOnDestroy() {
    const configGroup = (this.editForm.get('config') as FormGroup);

    if (configGroup) {
      configGroup.removeControl('wsId');

      if (Object.keys(configGroup.controls).length <= 0) {
        this.editForm.removeControl('config');
      }
    }

    this.subs.unsubscribe();
  }

}
